module.exports = "<svg width=\"63px\" height=\"63px\" viewBox=\"0 0 63 63\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>Align Right</title>\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#525151\" d=\"M0 63h63V0H0z\"/>\n    <g transform=\"matrix(0 -1 -1 0 43 46)\" fill=\"#FFF\">\n      <rect x=\"6\" y=\"4\" width=\"7\" height=\"19\" rx=\"1\"/>\n      <rect x=\"16\" y=\"4\" width=\"7\" height=\"11.881\" rx=\"1\"/>\n      <rect y=\".163\" width=\"28.309\" height=\"1.718\" rx=\".859\"/>\n    </g>\n  </g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/align/align-right.svg
// module id = 826
// module chunks = 0